import STORE_CONST from '../consts'
import teamApi from '../../api/team'

const state = {
	team: {
		list: [],
		members: {},
		setting: {},
		groupList: [],
		group: [],
	},
}

const mutations = {
	[STORE_CONST.TEAM.LIST](state, list) {
		state.team.list = list
	},
	[STORE_CONST.TEAM.CURRENT](state, setting) {
		state.team.setting = setting
	},
	[STORE_CONST.TEAM.GET_MEMBER](state, members) {
		state.team.members = members
	},
	[STORE_CONST.TEAM.GROUP_LIST](state, groupList) {
		state.team.groupList = groupList
	},
	[STORE_CONST.TEAM.GET_GROUP](state, group) {
		state.team.group = group
	},
}

const actions = {
	// get team list
	[STORE_CONST.TEAM.LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.getList(params).then((res) => {
				commit(STORE_CONST.TEAM.LIST, res.data.objects)
				resolve(res.data)
			})
		})
	},
	// get team member list v1
	[STORE_CONST.TEAM.GET_MEMBER_LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.getMemberList(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// add team member
	[STORE_CONST.TEAM.ADD]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.addMember(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// get current team set info
	[STORE_CONST.TEAM.CURRENT]({ commit }) {
		return new Promise((resolve, reject) => {
			teamApi
				.getCurrent()
				.then((res) => {
					commit(STORE_CONST.TEAM.CURRENT, res.data)
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// set current team info
	[STORE_CONST.TEAM.SET]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.setTeam(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// get team member info
	[STORE_CONST.TEAM.GET_MEMBER]({ commit }, id) {
		return new Promise((resolve, reject) => {
			teamApi.getMember(id).then((res) => {
				commit(STORE_CONST.TEAM.GET_MEMBER, res.data)
				resolve(res.data)
			})
		})
	},
	// edit team member info
	[STORE_CONST.TEAM.EDIT_MEMBER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.editMember(params).then((res) => {
				// commit(STORE_CONST.TEAM.GET_MEMBER, res.data)
				resolve(res.data)
			})
		})
	},
	// delete team Member
	[STORE_CONST.TEAM.DELETE]({ commit }, id) {
		return new Promise((resolve, reject) => {
			teamApi.deleteMember(id).then((res) => {
				resolve(res.data)
			})
		})
	},
	// get group list
	[STORE_CONST.TEAM.GROUP_LIST]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.getGroupList(params)
				.then((res) => {
					commit(STORE_CONST.TEAM.GROUP_LIST, res.data.objects)
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// get group  members list
	[STORE_CONST.TEAM.GET_GROUP_MEMBERS]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.getGroupMemberList(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// add team group
	[STORE_CONST.TEAM.ADD_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.addGroup(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// edit team group info
	[STORE_CONST.TEAM.EDIT_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.editGroup(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// delete team Group
	[STORE_CONST.TEAM.DELETE_GROUP]({ commit }, id) {
		return new Promise((resolve, reject) => {
			teamApi
				.deleteGroup(id)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// get group info
	[STORE_CONST.TEAM.GET_GROUP]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.getGroup(params)
				.then((res) => {
					commit(STORE_CONST.TEAM.GET_GROUP, res.data.members)
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// group add member
	[STORE_CONST.TEAM.GROUP_ADD_MEMBER]({ commit }, params) {
		console.log('aa')
		return new Promise((resolve, reject) => {
			teamApi
				.groupAddMember(params)
				.then((res) => {
					console.log('succ')
					resolve(res.data)
				})
				.catch((err) => {
					console.log('err')
					reject(err)
				})
		})
	},
	// group delete member
	[STORE_CONST.TEAM.DEL_GROUP_MEMBER]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.deleteGroupMember(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// get team statistic
	[STORE_CONST.TEAM.GET_STATISTIC_TEAM]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.getStatistic(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// get team resource statistic
	[STORE_CONST.TEAM.GET_RESOURCE_STATISTIC_TEAM]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.getResourceStatistic(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 获取套餐信息
	[STORE_CONST.TEAM.GET_PLAN]({ commit }, id) {
		return new Promise((resolve, reject) => {
			teamApi.getPlanInfo(id).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 更新团队Token
	[STORE_CONST.TEAM.UPDATE_TEAM_TOKEN]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.updateTeamToken(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 解绑EE工作空间、
	[STORE_CONST.TEAM.UNBIND_WORKSPACE]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi.unBindWorkSpace(params).then((res) => {
				resolve(res.data)
			})
		})
	},
	// 重置MFA
	[STORE_CONST.TEAM.RESET_MFA]({ commit }, params) {
		return new Promise((resolve, reject) => {
			teamApi
				.resetMFA(params)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
	// 获取SSO配置
	[STORE_CONST.TEAM.GET_SSO_CONFIG]({ commit }) {
		return new Promise((resolve, reject) => {
			teamApi
				.getSSOConfig()
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},

	// 更新SSO配置
	[STORE_CONST.TEAM.UPDATE_SSO_CONFIG]({ commit }, data) {
		return new Promise((resolve, reject) => {
			teamApi
				.updateSSOConfig(data)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},

	// 获取NTP配置
	[STORE_CONST.TEAM.GET_NTP_CONFIG]({ commit }) {
		return new Promise((resolve, reject) => {
			teamApi
				.getNTPConfig()
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},

	// 更新NTP配置
	[STORE_CONST.TEAM.UPDATE_NTP_CONFIG]({ commit }, data) {
		return new Promise((resolve, reject) => {
			teamApi
				.updateNTPConfig(data)
				.then((res) => {
					resolve(res.data)
				})
				.catch((err) => {
					reject(err)
				})
		})
	},
}

const getters = {
	team: (state) => {
		return state.team
	},
}

export default {
	state,
	mutations,
	actions,
	getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/team.js